<template>
  <BaseTemplate>
    <block>
      <h1>SMS認証</h1>
      <div v-if="pageMode == 0" class="memo">電話番号を入力してください。</div>
      <div v-if="pageMode == 1" class="memo">ご登録の電話番号に送信された6桁の認証コードをご入力ください。</div>
      <div v-if="pageMode == 2" class="memo">すでに認証済みです。</div>
      <div v-if="errorMessage" class="error"><span>×</span>{{ errorMessage }}</div>
      <div v-if="pageMode == 0" class="block">
        <div class="label">電話番号</div>
        <TextBox class="text-box tel" inputType="Number" :value="tel" placeholder="00012345678"
          @handleTextInput="inputTel" />
        <ErrorMessage v-if="errorMessageTel" class="error-message" :message="errorMessageTel" />
        <BlackGradationButton
          class="label-input nomt sms_button"
          className="small"
          text="認証コードを送る"
          @handleSquareBtnClick="btnInputTel" />
      </div>
      <div v-if="pageMode == 1" class="block sms_block">
        <TextBox class="text-box tel" inputType="Number" :value="smscode" placeholder="認証コードを入力"
          @handleTextInput="codeChange" />
        <ErrorMessage v-if="errorMessageSmscode" class="error-message" :message="errorMessageSmscode" />
        <BlackGradationButton
          class="label-input nomt sms_button"
          className="small"
          text="認証する"
          @handleSquareBtnClick="btnInputCode" />
      </div>
      <div v-if="pageMode == 2">
        <BlackGradationButton
          class="label-input nomt top_button hanten"
          className="small"
          text="TOPへ戻る"
          @handleSquareBtnClick="btnGoToTop" />
      </div>
    </block>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';

export default {
  components: {
    BaseTemplate,
    TextBox,
    ErrorMessage,
    BlackGradationButton,
  },

  data: () => ({
    errorMessage: '',
    pageMode: 0,
    smscode: '',
  }),

  computed: {
    ...mapGetters({
      sendSMS: 'sms/sendSMS',
      checkSMS: 'sms/checkSMS',
      currentUserDetail: 'user/currentUserDetail',
    }),
  },

  watch: {
    currentUserDetail(newVal) {
      if (newVal.end_sms === '1') {
        this.pageMode = 2;
      }
    },
    sendSMS(newVal) {
      if (newVal.state !== 200) {
        alert('入力された電話番号の形式が正しくありません。');
        window.location.reload();
        return;
      }
      if (newVal.errors && newVal.errors.tel) {
        alert(newVal.errors.tel);
        return;
      }
      if (newVal.errors && newVal.errors.user_id) {
        alert(newVal.errors.user_id);
        return;
      }
      this.pageMode = 1;
    },
    checkSMS(newVal) {
      this.errorMessage = '';
      if (newVal.state === 200) {
        this.$router.push({ path: '/sms/success' });
        return;
      }
      if (newVal.errors.sms_code) {
        this.$router.push({ path: '/sms/error' });
      }
    },
  },

  mounted() {
    if (this.$route.query.pageMode === 1) {
      this.pageMode = 1;
    } else {
      this.pageMode = 0;
    }
  },

  methods: {
    inputTel(tel) {
      this.tel = tel;
    },
    codeChange(value) {
      this.smscode = value;
    },
    btnInputTel() {
      const postParams = { tel: this.tel };
      this.$store.dispatch('sms/sendSMS', { postParams });
    },
    btnInputCode() {
      if (!this.smscode) {
        alert('認証コードを入力してください。');
        return;
      }
      const postParams = { sms_code: this.smscode };
      this.$store.dispatch('sms/checkSMS', { postParams });
    },
    btnGoToTop() {
      this.$router.push({ path: '/' });
    },
  },
};
</script>

<style lang="scss" scoped>
block {
  margin: 40px auto 200px auto;
  max-width: 800px;
  display: block;
  @media screen and  (max-width: $tabletWidth) {
    padding: 0 20px;
  }
  h1 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 30px;
  }
  .memo {
    text-align: center;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .error {
    text-align: center;
    font-weight: bold;
    margin-bottom: 30px;
    border: solid 1px #fc615f;
    color: #fc615f;
    font-size: 12px;
    display: flex;
    align-items: center;
    padding: 10px 10px;
    span {
      border: solid 2px #fc615f;
      border-radius: 100px;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
    }
  }
  .block {
    background-color: #f5f5f5;
    padding: 20px 40px;
    border-radius: 5px;
    &.sms_block {
      padding-top: 50px;
    }
    .label {
      font-weight: bold;
      margin-bottom: 10px;
    }
    .sms_button {
      margin-top: 40px;
      width: 240px;
      padding: 10px 0;
      margin: 40px auto 20px auto;
    }
  }
  .top_button {
    width: 300px;
    margin: auto;
  }
}
</style>
